import React from "react";
import { t } from "utilities/localization-utils";

const CSS_CLASS_NAME = "c-code-reference-block-content";

const CodeReferencePlaceholder = () => {
    return (
        <div className={`${CSS_CLASS_NAME}__placeholder`}>
            {t("addCodeSectionFromReferencePanel")}
        </div>
    );
};

export default CodeReferencePlaceholder;
